// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})
Vue.use(VueProgressBar, {
  color: 'rgba(0,120,255,1)',
  failedColor: 'red',
  thickness: '2px'
})

// Router
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/:language/',
      name: 'home'
    },
    {
      path: '/:language/overons/',
      name: 'overons'
    },
    {
      path: '/:language/meedoen/',
      name: 'meedoen'
    },
    {
      path: '/:language/programma/',
      name: 'programma'
    },
    {
      path: '/:language/nieuws/',
      name: 'nieuws'
    },
    {
      path: '/:language/verdieping/',
      name: 'verdieping'
    },
    {
      path: '/:language/zoek/:slug',
      name: 'zoek'
    },
    {
      path: '/:language/tag/:slug',
      name: 'tag'
    },
    {
      path: '/:language/verdieping-archief',
      name: 'verdieping-archief'
    },
    {
      path: '/:language/verdieping-programma',
      name: 'verdieping-programma'
    },
    {
      path: '/:language/verdieping-essays',
      name: 'verdieping-essays'
    },
    {
      path: '/:language/verdieping-mapping',
      name: 'verdieping-mapping'
    },
    {
      path: '/:language/verdieping-links-naar-meer',
      name: 'verdieping-links-naar-meer'
    },
    {
      path: '/:language/verdieping-klankbordgroep',
      name: 'verdieping-klankbordgroep'
    },
    {
      path: '/:language/:slug/',
      name: 'single'
    }
  ]
})

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js